import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Api from '../../component/Api';
import logo from '../../Assets/img/logo-small.png';


import '../../Assets/css/vendors/bootstrap.css';


function Login() {

    localStorage.removeItem('token');// To prevent users from navigating back to the previous page after arriving at the login page

    const { http } = Api();
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const [loginError, setLoginError] = useState('');
    const [emailError, setEmailError] = useState(''); //20/3/2024
    const [passwordError, setPasswordError] = useState(''); //20/3/2024

    //email validation
    const isValidEmail = (value) => {
        // Regular expression for email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(value);
    };



    const submitForm = (e) => {
        e.preventDefault(); // Prevent default form submission

        if (!password && !email) {
            setEmailError('Please enter valid email');
            setPasswordError('Please enter valid password');
            document.getElementById('exampleInputEmail').focus();
        } else if (!password) {
            setPasswordError('Please enter valid Password');
            setEmailError('');
            document.getElementById('exampleInputPassword').focus();
        } else if (!email) {
            setPasswordError('');
            setEmailError('Please enter valid user id');
            document.getElementById('exampleInputEmail').focus();
            // } else if (!isValidEmail(email)) {
            //     setPasswordError('');
            //     setEmailError('Please enter valid email');
            //     document.getElementById('exampleInputEmail').focus();
        } else {
            // Reset login field error state if both fields have input
            setEmailError('');
            setPasswordError('');

            http.post('/Sfalogin', { user_id: email, password: password })
                .then(res => {
                    if (res.data.token) {
                        console.log(res.data.token);
                        localStorage.setItem('token', res.data.token);
                        navigate('/ino/vendorlist'); // Use relative path
                    } else {
                        setLoginError('Login failed. Please try again.');
                    }
                })
                .catch(error => {
                    console.error('Login error:', error);
                    setLoginError('Invalid Username or Password');
                });
        }
    };



    return (
        <div className="container-fluid bg-gradient-primary">
            <div className="row justify-content-center flex-grow-1">
                <div className="col-xl-5 col-lg-12 col-md-9">
                    <div className="o-hidden border-0 shadow-lg my-5 brd-rad bk-clr">
                        <div className="card-body p-0">
                            <div className="row">

                                <div className="col-lg-12">
                                    <div className="p-5">
                                        <div className="circle23">
                                            <img className="img-fluid for-light" src={logo} alt="MGU Logo" />
                                        </div>
                                        <div className="heading12 text-center">Sign in to Your Account</div>
                                        <br></br>
                                        <form onSubmit={submitForm}>
                                            <div className="user mt-2">
                                                {loginError && (
                                                    <div className="alert alert-danger" role="alert">
                                                        <p style={{ textAlign: 'center', textJustify: 'auto' }}>{loginError}</p>
                                                    </div>
                                                )}

                                                <div className="form-group">

                                                    <input
                                                        type="text"
                                                        className="form-control "
                                                        id="exampleInputEmail"
                                                        placeholder="Login User ID"
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        style={{ width: '100%' }}
                                                    />
                                                    {emailError && <p className="text-danger">{emailError}</p>}
                                                </div>
                                                <br></br>

                                                <div className="form-group">

                                                    <div className="form-input position-relative">
                                                        <div style={{ position: 'relative' }}>
                                                            <input

                                                                type={showPassword ? "text" : "password"}
                                                                className="form-control form-control-user"
                                                                id="exampleInputPassword"
                                                                placeholder="***********"
                                                                onChange={(e) => setPassword(e.target.value)}
                                                                style={{ width: '100%' }}

                                                            />
                                                            <span className="show-hide" style={{ position: 'absolute', top: '50%', transform: 'translateY(-50%)', right: '10px', cursor: 'pointer' }} onClick={() => setShowPassword(!showPassword)}>
                                                                {showPassword ? <i className="fa fa-eye-slash fa-stl"></i> : <i className="fa fa-eye fa-stl"></i>}
                                                            </span>

                                                        </div>
                                                    </div>
                                                    {passwordError && <p className="text-danger">{passwordError}</p>}
                                                </div>
                                                <div className="st-lgn-pdg1" style={{textAlign:'center',marginTop:'20px'}}>
                                                    <a href="#/ino/forgetpassword" className="forgot-password23">Forgot Password..?</a>
                                                </div>
                                                <br></br>
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-user btn-block bt"

                                                    style={{ width: '100%' }}
                                                >
                                                    <h6>Login</h6>
                                                </button>
                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer className="footer foot-wt">
                <div className="container my-auto">
                    <div className="copyright text-center my-auto">
                        <span style={{ color: 'black' }}>
                            &copy; <a style={{ color: 'black' }} href="https://www.mgu.ac.in/" target="_blank">Mahatma Gandhi University, Priyadarsini Hills, Kottayam, Kerala, India - 686560</a>
                        </span>
                    </div>
                </div>
            </footer>
        </div>


    );
}

export default Login;

